
import React from 'react';
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

export default function SharedAdminLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar />
            <div className="flex-1 flex flex-col overflow-hidden">
                <Topbar />
                <div className="flex-1 overflow-y-auto space-y-4 p-8 pt-6">
                    {children}
                </div>
            </div>
        </div>
    );
}
